export default "__VITE_ASSET__Bt4qC4Gv__"